import { ReactNode } from "react"
import { css, cx } from "@emotion/css"

const styles = {
  root: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0 var(--spacing-m);

    .left {
      display: flex;
      align-items: center;
      & > :not(:first-child) {
        margin-left: var(--spacing-m);
      }
    }

    .right {
      display: flex;
      align-items: center;
      gap: var(--spacing-m);
    }
  `,
}

export type TableToolbarProps = {
  children: ReactNode
  className?: string
}

export function TableToolbar(props: TableToolbarProps) {
  const { children, className } = props
  return <div className={cx(styles.root, className)}>{children}</div>
}
